module.exports = __webpack_public_path__ + "static/lighthouse-ff8f1cba46e6f36aca5d531a7d7357c1.png";